import React, { useEffect, useMemo, useRef, useState } from 'react';
import { BuildPath } from '../../../helpers/Paths';
import { SearchResultsProps, Status } from '../../../interfaces/unsplash';

const SearchResults = (props:{data:SearchResultsProps}) => {

    const { ref, onScroll, images, setBigImage, bigImage, status, keyword } = props.data;
    
    const keyValue = useMemo(() => {
        return keyword;
    }, [images.length, status])

    const truncate = (str, n) => {

        if (!str) {
            return "";
        }

        return (str.length > n) ? str.substr(0, n - 1) + '...' : str;
    };

    const selectedImage = (id:string):string => {

        if (bigImage !== null && bigImage.id === id){
            return "image-item selected-image"
        }

        return "image-item";
    }

    // No results
    if (status === Status.finished && images.length === 0){
        return (
            <div className="no-results-container">
                <div className="no-results-icon">
                    <img src={`${BuildPath()}/images/unsplash/missing.svg`} alt="Unsplash" />
                    <p>No results found for "{keyValue}"</p>
                </div>
            </div>
        )
    }

    return (
        <section className="search-results" ref={ref} onScroll={onScroll}>

            {images.map(x => {
                return (
                    <div className={selectedImage(x.id)} key={x.id}>
                        <div className="image-container" 
                            onClick={() => setBigImage(x)} 
                            style={{  
                                backgroundImage: "url(" + x.imageSmall + ")",
                                backgroundPosition: 'center',
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat'
                            }}>
                            
                        </div>
                        <span>{truncate(x.filename, 14)}</span>
                    </div>
                );
            })}

        </section>
    );
};

export default SearchResults;